<script setup lang="ts">
  import { Download } from "lucide-vue-next";
  import { storeToRefs } from "pinia";

  import { Button } from "@/components/ui/button";

  import { useSurveyStore } from "@stores/survey/survey";
  import { useSurveyLocalesStore } from "@stores/survey/surveyLocales";

  const surveyStore = useSurveyStore();
  const { isExportingCards } = storeToRefs(surveyStore);
  const { localeModel } = storeToRefs(useSurveyLocalesStore());
</script>

<template>
  <Button
    variant="outline"
    :disabled="isExportingCards"
    @click="surveyStore.exportCards(localeModel)">
    <Download class="h-4 w-4" />
    Export
  </Button>
</template>
